import parse from 'html-react-parser';

//components
import { Container } from '@/components/Grid';
import {
  Section,
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';

import { FreightExperts } from '@/containers-latam/FreightExperts';
import { PillLink } from '@/containers-ai/Buttons';
import { CountUp } from '@/containers-latam/CountUp';
import { PlatformScale } from '@/containers-latam/PlatformScale';

//data
import { STAGES } from '../../agents';

//styles
import {
  AutomateSection,
  Head,
  Proof,
  ProofValue,
  ProofText,
  Group,
  GroupLabel,
  Row,
  RowStat,
  RowStatValue,
  RowStatLabel,
  RowTitle,
  RowText,
  ReadMore,
  CustomBand,
  CustomTitle,
  CustomCopy,
} from './LiveInProduction.styles';

// "What we automate": the detail behind The lineup, grouped by the same four
// lifecycle stages, followed by the Freight Experts block and the platform
// numbers. `agentHrefs` maps each agent to the page its "read more" opens.
export function LiveInProduction({
  content,
  freightExpertsContent,
  platformScaleContent,
  agentHrefs,
  ctaHref = '/contact/#contact-form',
  numberLocale,
}) {
  return (
    <>
      <AutomateSection id="automate">
        <Container>
          <Head>
            <div>
              <Kicker>
                <KickerDot />
                {content.kicker}
              </Kicker>
              <SectionTitle style={{ maxWidth: '905px' }}>
                {content.title}
                <br />
                <Grad>{content.titleHighlight}</Grad>
              </SectionTitle>
              <SectionLede style={{ maxWidth: '520px' }}>
                {content.lede}
              </SectionLede>
            </div>
            <Proof>
              <ProofValue>
                {content.bigProof.prefix}
                <CountUp value={content.bigProof.value} locale={numberLocale} />
                {content.bigProof.suffix ?? '+'}
              </ProofValue>
              <ProofText>{parse(content.bigProof.copy)}</ProofText>
            </Proof>
          </Head>

          {STAGES.map((stage) => (
            <Group key={stage.id} id={`stage-${stage.id}`}>
              <GroupLabel>
                <i />
                <h3>{content.stages[stage.key]}</h3>
              </GroupLabel>
              <div>
                {stage.slugs.map((slug) => {
                  const agent = content.agents[slug];

                  return (
                    <Row key={slug} id={`agent-${slug}`}>
                      <RowStat>
                        <RowStatValue>{agent.metric}</RowStatValue>
                        <RowStatLabel>{agent.label}</RowStatLabel>
                      </RowStat>
                      <div>
                        <RowTitle>{agent.title}</RowTitle>
                        <RowText>{agent.description}</RowText>
                      </div>
                      <ReadMore href={agentHrefs[slug]}>
                        {content.readMoreLabel}
                      </ReadMore>
                    </Row>
                  );
                })}
              </div>
            </Group>
          ))}

          <CustomBand id="custom">
            <div>
              <Kicker>
                <KickerDot />
                {content.customCard.kicker}
              </Kicker>
              <CustomTitle>{content.customCard.title}</CustomTitle>
              <CustomCopy>{content.customCard.copy}</CustomCopy>
            </div>
            <PillLink
              href={ctaHref}
              className="qlf-btn-2"
              style={{ whiteSpace: 'nowrap' }}
            >
              {content.customCard.ctaLabel}
            </PillLink>
          </CustomBand>
        </Container>
      </AutomateSection>

      <Section id="operators-and-scale">
        <Container>
          <FreightExperts border={false} content={freightExpertsContent} />
          <PlatformScale
            stats={Object.values(platformScaleContent.stats)}
            label={platformScaleContent.label}
            locale={numberLocale}
          />
        </Container>
      </Section>
    </>
  );
}
